export default __webpack_public_path__ + "static/media/technology.11750c6e.jpg";